/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as ShareShareIdRouteImport } from './routes/share.$shareId'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const ShareShareIdRoute = ShareShareIdRouteImport.update({
  id: '/share/$shareId',
  path: '/share/$shareId',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/share/$shareId': typeof ShareShareIdRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/share/$shareId': typeof ShareShareIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/share/$shareId': typeof ShareShareIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths: '/' | '/share/$shareId'
  fileRoutesByTo: FileRoutesByTo
  to: '/' | '/share/$shareId'
  id: '__root__' | '/' | '/share/$shareId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  ShareShareIdRoute: typeof ShareShareIdRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/share/$shareId': {
      id: '/share/$shareId'
      path: '/share/$shareId'
      fullPath: '/share/$shareId'
      preLoaderRoute: typeof ShareShareIdRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  ShareShareIdRoute: ShareShareIdRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
